module.exports = __webpack_public_path__ + "static/media/logotipo_fato.8825bf41.png";